export const applyDateMask = (value) => {
  // Remove any non-digit characters
  const digits = value.replace(/\D/g, "");
  
  // Apply the mask
  let maskedValue = "";
  if (digits.length > 0) {
    maskedValue = digits.substring(0, 2);
    if (digits.length > 2) {
      maskedValue += "/" + digits.substring(2, 4);
      if (digits.length > 4) {
        maskedValue += "/" + digits.substring(4, 8);
      }
    }
  }
  
  return maskedValue;
};

export const validateDate = (value, t) => {
  if (!value) {
    return "";
  }
  
  // Check if the format is correct (dd/mm/yyyy)
  const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!dateRegex.test(value)) {
    return t("Please enter a valid date in dd/mm/yyyy format");
  }
  
  // Check if the date is valid
  const [day, month, year] = value.split("/").map(Number);
  const date = new Date(year, month - 1, day);
  
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return t("Please enter a valid date");
  }
  
  return "";
};

// Convert date from DD/MM/YYYY to YYYY-MM-DD format for backend
export const formatDateForBackend = (dateString) => {
  if (!dateString) return null;
  
  const [day, month, year] = dateString.split('/');
  if (!day || !month || !year) return null;
  
  return `${year}-${month}-${day}`;
};

// Convert date from YYYY-MM-DD to DD/MM/YYYY format for frontend
export const formatDateForFrontend = (dateString) => {
  if (!dateString) return "";
  
  // Check if the date is already in DD/MM/YYYY format
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }
  
  // Check if the date is in YYYY-MM-DD format
  const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [_, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }
  
  return dateString;
};